import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import { useGaudiLocalization } from '../Provider/Provider.js';
import { Group } from '../Group/Group.js';
import { PageNumbers } from './PageNumbers.js';
import { Select } from '../Select/Select.js';
import { usePaginationShortcuts } from './usePaginationShortcuts.js';
export { usePagination } from './usePagination.js';

var _excluded = ["length", "pageIndex", "pageSize", "pageSizes", "setPageIndex", "setPageSize", "showPageControls", "showPageNumbers", "showPageSize", "dangerouslyHijackGlobalKeyboardNavigation"];

var getShowingLabel = function getShowingLabel(length, pageIndex, pageSize, texts) {
  var minItemIndex = pageIndex * pageSize + 1;
  var maxItemIndex = (pageIndex + 1) * pageSize;
  return texts.pagination.showingXofYofTotal.replace('[X]', length === 0 ? '0' : String(minItemIndex)).replace('[Y]', String(maxItemIndex > length ? length : maxItemIndex)).replace('[total]', String(length));
};

var Pagination = /*#__PURE__*/forwardRef(function Pagination(props, ref) {
  var length = props.length,
      pageIndex = props.pageIndex,
      pageSize = props.pageSize,
      _props$pageSizes = props.pageSizes,
      pageSizes = _props$pageSizes === void 0 ? [10, 25, 50, 100, 500] : _props$pageSizes,
      setPageIndex = props.setPageIndex,
      setPageSize = props.setPageSize,
      _props$showPageContro = props.showPageControls,
      showPageControls = _props$showPageContro === void 0 ? true : _props$showPageContro,
      _props$showPageNumber = props.showPageNumbers,
      showPageNumbers = _props$showPageNumber === void 0 ? true : _props$showPageNumber,
      _props$showPageSize = props.showPageSize,
      showPageSize = _props$showPageSize === void 0 ? true : _props$showPageSize,
      _props$dangerouslyHij = props.dangerouslyHijackGlobalKeyboardNavigation,
      dangerouslyHijackGlobalKeyboardNavigation = _props$dangerouslyHij === void 0 ? false : _props$dangerouslyHij,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var _useGaudiLocalization = useGaudiLocalization(),
      texts = _useGaudiLocalization.texts;

  var maxPageIndex = Math.ceil(length / pageSize) - 1;
  var showShortcutTexts = dangerouslyHijackGlobalKeyboardNavigation;
  usePaginationShortcuts({
    setPageIndex: setPageIndex,
    maxPageIndex: maxPageIndex,
    pageIndex: pageIndex,
    dangerouslyHijackGlobalKeyboardNavigation: dangerouslyHijackGlobalKeyboardNavigation
  });
  var pageCount = Math.ceil(length / pageSize);
  var canPreviousPage = pageIndex > 0;
  var canNextPage = pageIndex < pageCount - 1;
  var className = cn('yt-pagination', props.className);
  return createElement("div", Object.assign({}, otherProps, {
    className: className,
    ref: ref
  }), showPageSize && createElement("span", null, getShowingLabel(length, pageIndex, pageSize, texts), createElement(Select, {
    "aria-label": texts.pagination.pageSize,
    className: "ml-4 w-20",
    data: pageSizes.map(function (pageSize) {
      return {
        text: String(pageSize),
        value: pageSize
      };
    }),
    onChange: function onChange(event) {
      setPageIndex(0);
      setPageSize(Number(event.target.value));
    },
    value: pageSize
  })), showPageControls && createElement(Group, {
    as: "nav",
    "aria-label": texts.pagination.label
  }, createElement(IconButton, {
    appearance: "default",
    disabled: !canPreviousPage,
    icon: "arrow-start",
    onClick: function onClick() {
      return setPageIndex(0);
    },
    "aria-label": showShortcutTexts ? texts.pagination.actions.firstPageWithShortcut : texts.pagination.actions.firstPage,
    tooltip: showShortcutTexts ? texts.pagination.actions.firstPageWithShortcut : texts.pagination.actions.firstPage
  }), createElement(IconButton, {
    appearance: "default",
    disabled: !canPreviousPage,
    icon: "arrow-left",
    onClick: function onClick() {
      return setPageIndex(pageIndex - 1);
    },
    "aria-label": showShortcutTexts ? texts.pagination.actions.previousPageWithShortcut : texts.pagination.actions.previousPage,
    tooltip: showShortcutTexts ? texts.pagination.actions.previousPageWithShortcut : texts.pagination.actions.previousPage
  }), showPageNumbers && pageCount > 0 && createElement(PageNumbers, {
    pageCount: pageCount,
    currentPageIndex: pageIndex,
    onClick: setPageIndex
  }), createElement(IconButton, {
    appearance: "default",
    disabled: !canNextPage,
    icon: "arrow-right",
    onClick: function onClick() {
      return setPageIndex(pageIndex + 1);
    },
    "aria-label": showShortcutTexts ? texts.pagination.actions.nextPageWithShortcut : texts.pagination.actions.nextPage,
    tooltip: showShortcutTexts ? texts.pagination.actions.nextPageWithShortcut : texts.pagination.actions.nextPage
  }), createElement(IconButton, {
    appearance: "default",
    disabled: !canNextPage,
    icon: "arrow-end",
    onClick: function onClick() {
      return setPageIndex(pageCount - 1);
    },
    "aria-label": showShortcutTexts ? texts.pagination.actions.lastPageWithShortcut : texts.pagination.actions.lastPage,
    tooltip: showShortcutTexts ? texts.pagination.actions.lastPageWithShortcut : texts.pagination.actions.lastPage
  })));
});

export { Pagination };
//# sourceMappingURL=Pagination.js.map
